module.exports = __webpack_public_path__ + "static/media/product_sences_bg.97ef9b48.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/product_sences_bg.png
// module id = 640
// module chunks = 0